import { schema } from "normalizr";

export const smartDatePlanSchema = new schema.Entity("smartDatePlan", {});

export const smartDatePlansSchema = new schema.Array(smartDatePlanSchema);
